import { api } from "@/api"

export type ValidatePasswordResetTokenResponse = {
  email: string
  first_name: string
  last_name: string
}

export const validatePasswordResetToken = async (
  token: string
) => {
  const { body } =
    await api.post<ValidatePasswordResetTokenResponse>(
      "/auth/validate-password-reset-token/",
      { body: { token }, authenticated: false } // Authenticated: false needed to ensure request routes to public tenant
    )
  return body
}
